import React, { useEffect, useState } from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalGoogleSheetsIntegrationForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../ui/Title/Title";
import Input from "../../ui/Input/Input";
import Button from "../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import { useModal } from "../../context/ModalContext";
import {
  setActiveDataBitrixChatBot,
  setNewDataBitrixChatBot,
} from "../../store/slices/bitrixChatBotSlice";
import { GoogleSheetIcon } from "../../assets/icons/GoogleSheetIcon";
import { setIsUpdateGoogleSheets } from "../../store/slices/googleSheetsSlice";
import Select from "../../ui/Select/Select";
import AddFilesIcon from "../../assets/icons/AddFilesIcon";
import FileCard from "../FileCard/FileCard";
import { FileUpload } from "../../ui/FileUpload/FileUpload";
import { initGoogleSheet } from "../../utils/api/actions/integrations/googleSheets";

const GoogleSuccessMessage = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();

  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      //   dispatch(getIntegrationsBitrixList(id));
      dispatch(setActiveDataBitrixChatBot(null));
      dispatch(setNewDataBitrixChatBot(null));
    }

    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, id, closeAddIntegrationModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили Google Sheets!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalGoogleSheetsIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();

  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);
  const { dataAssistants } = useSelector(
    (state) => state?.assistant
  );

  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [updatedGoogleSheetsData, setUpdatedGoogleSheetsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState("");
  const [driveFile, setDriveFile] = useState(null);

  const assistantName =
    dataAssistants?.find(
      (assistant) => assistant.id === updatedGoogleSheetsData?.assistantId
    )?.name || "Ассистент не найден";

  const formatFileSize = (size) => {
    if (!size) return null;

    if (size < 1024) {
      return `${size.toFixed(2)} KB`;
    } else {
      return `${(size / 1024).toFixed(2)} MB`;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "link") setLink(value);
  };

  const selectObserver = (val) => {
    dispatch(setIsUpdateGoogleSheets(true));
    setUpdatedGoogleSheetsData((prevData) => ({
      ...prevData,
      assistantId: val,
    }));
  };

  const handleSendDataInitGoogleSheet = () => {
    const formData = new FormData();

    formData.append("userId", user.id);
    formData.append("assistantId", updatedGoogleSheetsData?.assistantId || "");
    formData.append("spreadSheetLink", link);

    if (driveFile) {
      formData.append("SheetFile", driveFile); // предполагается, что это Blob/File
    }

    dispatch(initGoogleSheet(formData, setLoading, setIsGoogleConnected));
  };

  return (
    <Modal
      styleClose={styles.closeIcon}
      visible={visible}
      handleClose={handlerClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <GoogleSheetIcon size={40} />
          <Title title="- документ" className={styles.subtitle} />
        </div>
        {isGoogleConnected ? (
          <GoogleSuccessMessage
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        ) : (
          <div className={styles.form}>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                name={"link"}
                label="Ссылка на документ"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={`${styles.input}`}
                value={link}
                placeholder={"https://docs.google.com/spreadsheets/"}
                type={"text"}
                onChange={handleInputChange}
              />
            </div>

            <Select
              containerStyle={styles.containerSelect}
              selectStyle={styles.select}
              labelStyle={styles.labelSelect}
              dataSelect={dataAssistants}
              selectObserver={selectObserver}
              nameSelectedOption={assistantName}
            />

            <div className={styles.inputContainer}>
              <div className={styles.addFilesContainer}>
                <div className={styles.filesList}>
                  {driveFile && (
                    <FileCard
                      name={driveFile.name}
                      size={formatFileSize(driveFile.size)}
                      handleDelete={() => setDriveFile(null)}
                    />
                  )}
                </div>
                {!driveFile && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "flex-start",
                    }}
                  >
                    <FileUpload
                      onFileSelected={setDriveFile}
                      acceptedFileType="application/json"
                      fileTypeErrorMessage="Неподдерживаемый файл! \n Выберите другой"
                      inputId="upload_file_google"
                      icon={<AddFilesIcon size={25} />}
                      mainLabel="JSON-ключ"
                      subLabel="Нажмите или перетащите файл сюда"
                    />
                  </div>
                )}
              </div>
            </div>

            <Button
              onClick={handleSendDataInitGoogleSheet}
              className={styles.button}
              titleClassName={styles.buttonTitle}
              leftIcon={
                loading ? <ClipLoader size={16} color={"white"} /> : null
              }
              title={loading ? "Подождите" : "Отправить"}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
